module.exports = __webpack_public_path__ + "static/img/constructBannera.cd457a2c.png";